
import { mapMutations } from 'vuex'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'TheOutcomeGradingOfGlasgow',
components: {
XTable
},
created () {
this.hideLoad()
},
methods: {
...mapMutations(['hideLoad'])
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/TheOutcomeGradingOfGlasgow.vue